<template>
  <VLayout>
    <template slot="title-header">
      <VMainTitle>
        <template slot="title">
          <i18n path="importmedicinesform.title" tag="span">
            <span place="country_name">
              <VCountryName :iso="deviceCountry" />
            </span>
          </i18n>
        </template>
      </VMainTitle>
    </template>

    <vue-element-loading :active="loading" />
    <vue-element-loading :active="saving" />
    <div class="importmedicines-body" v-if="!loading && international_trade_config">
      <b-row no-gutters>
        <b-col
          cols="12"
          lg="3"
          v-bind:class="countryFlagClass"
          class="flag-icon-background"
        >
        </b-col>
        <b-col cols="12" lg="9" class="pl-lg-3 main-data-text">
          <p>
            <strong>{{ $t("importmedicinesform.regulatory_org") }}: </strong>
            {{ international_trade_config.regulatory_org }}
          </p>
          <p>
            <strong>
              {{ $t("importmedicinesform.applicable_regulations") }}:
            </strong>
            {{ international_trade_config.applicable_regulations }}
          </p>
          <p>
            <strong>{{ $t("importmedicinesform.kind_of_procedure") }}: </strong>
            {{ international_trade_config.kind_of_procedure }}
          </p>
          <p>
            <strong>
              {{ $t("importmedicinesform.regulatory_agency_cost") }}:
            </strong>
            {{ international_trade_config.regulatory_agency_cost }}
          </p>
          <p>
            <strong>{{ $t("importmedicinesform.required_time") }}: </strong>
            {{ international_trade_config.required_time }}
          </p>
        </b-col>
      </b-row>

      <p class="text-uppercase heading mt-5 mb-4">
        {{ $t("importmedicinesform.request_data_title") }}
      </p>

      <b-row>
        <b-col cols="12" lg="6">
          <b-form-group
            label-cols="12"
            label-cols-lg="4"
            id="group_firstname"
            class="text-left required"
            :label="$t('importmedicinesform.firstname_label')"
            label-for="input_firstname"
            :invalid-feedback="form_invalid_feedback.firstname"
            :state="form_state.firstname"
          >
            <b-form-input
              id="input_firstname"
              v-model.trim="form.firstname"
              type="text"
              required
              :state="form_state.firstname"
              :placeholder="$t('importmedicinesform.firstname_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-lg="4"
            id="group_address"
            class="text-left required"
            :label="$t('importmedicinesform.address_label')"
            label-for="input_address"
            :invalid-feedback="form_invalid_feedback.address"
            :state="form_state.address"
          >
            <b-form-input
              id="input_address"
              v-model.trim="form.address"
              type="text"
              required
              :state="form_state.address"
              :placeholder="$t('importmedicinesform.address_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-lg="4"
            id="group_postal_code"
            class="text-left required"
            :label="$t('importmedicinesform.postal_code_label')"
            label-for="input_postal_code"
            :invalid-feedback="form_invalid_feedback.postal_code"
            :state="form_state.postal_code"
          >
            <b-form-input
              id="input_postal_code"
              v-model.trim="form.postal_code"
              type="text"
              required
              :state="form_state.postal_code"
              :placeholder="$t('importmedicinesform.postal_code_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-lg="4"
            id="group_mobile"
            class="text-left required"
            :label="$t('importmedicinesform.mobile_label')"
            label-for="input_mobile"
            :invalid-feedback="form_invalid_feedback.mobile"
            :state="form_state.mobile"
          >
            <PhoneNumberInput
              id="input_mobile"
              v-model="form.mobile"
              size="sm"
              required
            ></PhoneNumberInput>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group
            label-cols="12"
            label-cols-lg="4"
            id="group_identification_number"
            class="text-left required"
            :label="$t('importmedicinesform.identification_number_label')"
            label-for="input_identification_number"
            :invalid-feedback="form_invalid_feedback.identification_number"
            :state="form_state.identification_number"
          >
            <b-form-input
              id="input_identification_number"
              v-model.trim="form.identification_number"
              type="text"
              required
              :state="form_state.identification_number"
              :placeholder="
                $t('importmedicinesform.identification_number_placeholder')
              "
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-lg="4"
            id="group_town"
            class="text-left required"
            :label="$t('importmedicinesform.town_label')"
            label-for="input_town"
            :invalid-feedback="form_invalid_feedback.town"
            :state="form_state.town"
          >
            <b-form-input
              id="input_town"
              v-model.trim="form.town"
              type="text"
              required
              :state="form_state.town"
              :placeholder="$t('importmedicinesform.town_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-lg="4"
            id="group_phone"
            class="text-left required"
            :label="$t('importmedicinesform.phone_label')"
            label-for="input_phone"
            :invalid-feedback="form_invalid_feedback.phone"
            :state="form_state.phone"
          >
            <PhoneNumberInput
              id="input_phone"
              v-model="form.phone"
              size="sm"
              required
            ></PhoneNumberInput>
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-lg="4"
            id="group_email"
            class="text-left required"
            :label="$t('importmedicinesform.email_label')"
            label-for="input_email"
            :invalid-feedback="form_invalid_feedback.email"
            :state="form_state.email"
          >
            <b-form-input
              id="input_email"
              v-model.trim="form.email"
              type="text"
              required
              :state="form_state.email"
              :placeholder="$t('importmedicinesform.email_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <p class="text-uppercase heading mt-5 mb-4">
        {{ $t("importmedicinesform.documents_title") }}
      </p>

      <div
        v-if="international_trade_config.file_requirements_guide_and_process"
      >
        <div class="d-flex flex-row bd-highlight mb-4">
          <div class="bd-highlight">
            <h5 class="text-uppercase heading2 font-weight-semibold">
              {{ $t("importmedicinesform.guide_subtitle") }}
            </h5>
            <small>
              {{ $t("importmedicinesform.all_filled_info") }}
            </small>
          </div>
          <div class="pl-4 bd-highlight align-middle ">
            <b-link
              :href="international_trade_config.file_requirements_guide_and_process"
              class="btn btn-primary downloadbutton"
              target="_blank"
            >
              {{ $t("importmedicinesform.download_button") }}
            </b-link>
          </div>
        </div>
      </div>

      <ImportMedicinesFormFiles
        v-if="importation_cart"
        ref="importmedicinesformfiles"
        :international_trade_config="international_trade_config"
        :documentation="importation_cart.documentation"
      />

      <p class="text-uppercase heading mt-5 mb-4">
        {{ $t("importmedicinesform.drugs_title") }}
      </p>
      <VDrugsSummary
        v-if="importation_cart"
        :items="importation_cart_item_list_drugs"
        picturecolumn
        statecolumn
        taxcolumn
        discountcolumn
        adddrugbutton
        quantityinput
        v-on:drugsButtonClick="drugSelectorShow = true"
        showamount
        actionscolumn
        dirtycolumn
        @modifyQuantity="setItemQuantity"
        @deleteButtonClick="deleteItem"
        :isBusy="isDrugsSummaryBusy"
        :busyItemUuid="drugsSummaryBusyItemUuid"
      />
      <b-modal
        size="xl"
        v-model="drugSelectorShow"
        centered
        :title="$t('importmedicinesform.drug_selector_title')"
        hide-footer
      >
        <b-container fluid>
          <b-row>
            <b-col>
              <VDrugListSelector
                table_provider_dispatch="drugs/REQUEST_IMPORTATION_PHDRUGS"
                v-on:product:selected="onProductSelected"
                :perPage="5"
                :primary_button_text="$t('importmedicinesform.add_drug_button')"
              />
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
      <VButtonGroup
        prevent_primary_default
        v-on:primary-click="onSaveForm"
        :primary_text="$t('importmedicinesform.continue_button')"
        :secondary_to="{ name: 'importmedicineshome' }"
        between
      />
    </div>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import VLayout from "@/layouts/Default";
import VCountryName from "@/components/VCountryName";
import VButtonGroup from "@/components/VButtonGroup";
import VMainTitle from "@/components/VMainTitle";
import ImportMedicinesFormFiles from "@/components/ImportMedicinesFormFiles";
import VDrugsSummary from "@/components/VDrugsSummary";
import VDrugListSelector from "@/components/VDrugListSelector";
import PhoneNumberInput from "@/components/PhoneNumberInput";

export default {
  name: "import-medicines-form",
  components: {
    VLayout,
    VCountryName,
    VButtonGroup,
    VMainTitle,
    ImportMedicinesFormFiles,
    VDrugsSummary,
    VDrugListSelector,
    PhoneNumberInput,
  },
  computed: {
    ...mapGetters("auth", ["deviceCountry"]),
    ...mapGetters("drugtransaction", ["getImportationCartIsDirtyDrugs"]),
    ...mapState({
      international_trade_config: state =>
        state.organization.international_trade_config,
      importation_cart: state => state.drugtransaction.importation_cart,
      importation_cart_item_list_drugs: state =>
        state.drugtransaction.importation_cart_item_list_drugs,
    }),
    countryFlagClass: function() {
      return "flag-icon-" + this.deviceCountry.toLowerCase();
    },
  },
  data() {
    return {
      form: {
        firstname: "",
        identification_number: "",
        email: "",
        address: "",
        town: "",
        postal_code: "",
        mobile: "",
        phone: "",
      },
      form_invalid_feedback: {},
      form_state: {},
      loading: false,
      saving: false,
      drugSelectorShow: false,
      isDrugsSummaryBusy: false,
      drugsSummaryBusyItemUuid: null,
      trade_config: {
        regulatory_org: undefined,
        applicable_regulations: undefined,
        kind_of_procedure: undefined,
        regulatory_agency_cost: undefined,
        required_time: undefined,
      },
    };
  },
  mounted() {
    let promises = [];
    promises.push(this.REQUEST_INTERNATIONAL_TRADE_CONFIG());
    const cart_promise = this.REQUEST_IMPORTATION_CART();
    cart_promise.then(res => {
      if (res.data.importation) {
        this.form = res.data.importation;
        if (res.data.object_status == 2) {
          // Si hacemos esto y se queda en el carrito un producto
          // que no tiene métodos de envío, el usuario jamás
          // podrá volver a usar esta funcionalidad
          // this.$router.replace({
          //   name: "importmedicinesdone",
          // });
        }
      }
    });
    promises.push(cart_promise);
    this.loading = true;
    Promise.all(promises).then(
      () => {
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  },
  methods: {
    ...mapActions({
      REQUEST_INTERNATIONAL_TRADE_CONFIG:
        "organization/REQUEST_INTERNATIONAL_TRADE_CONFIG",
      REQUEST_IMPORTATION_CART: "drugtransaction/REQUEST_IMPORTATION_CART",
      ADD_DRAFT_IMPORTATION_CART_ITEM_LIST_DRUG:
        "drugtransaction/ADD_DRAFT_IMPORTATION_CART_ITEM_LIST_DRUG",
      REQUEST_CREATE_IMPORTATION_CART_DRUG:
        "drugtransaction/REQUEST_CREATE_IMPORTATION_CART_DRUG",
      REQUEST_UPDATE_IMPORTATION_CART_DRUG:
        "drugtransaction/REQUEST_UPDATE_IMPORTATION_CART_DRUG",
      REQUEST_DELETE_IMPORTATION_CART_DRUG:
        "drugtransaction/REQUEST_DELETE_IMPORTATION_CART_DRUG",
      REQUEST_UPDATE_IMPORTATION_CART_IMPORTATION:
        "drugtransaction/REQUEST_UPDATE_IMPORTATION_CART_IMPORTATION",
      REQUEST_CREATE_IMPORTATION_CART_IMPORTATION:
        "drugtransaction/REQUEST_CREATE_IMPORTATION_CART_IMPORTATION",
      REQUEST_UPDATE_IMPORTATION_CART:
        "drugtransaction/REQUEST_UPDATE_IMPORTATION_CART",
    }),
    onProductSelected(item) {
      // Los uuid de PhDrug y PhDrugPrice los colocamos
      // en los atributos parent para enviarlos
      // a core en un POST. Le decimos así desde dónde
      // queremos crear los snapshots
      const price = Object.assign(
        { parent: item.product.price.uuid },
        item.product.price,
        { uuid: undefined }
      );
      const product = Object.assign(
        { parent: item.product.uuid },
        item.product,
        { uuid: undefined },
        { price: price },
        item.extra_fields
      );

      this.ADD_DRAFT_IMPORTATION_CART_ITEM_LIST_DRUG(product);
      this.drugSelectorShow = false;
    },
    setItemQuantity(item, newValue) {
      this.$store.commit(
        "drugtransaction/MUTATE_QUANTITY_DRAFT_IMPORTATION_CART_ITEM_LIST_DRUG",
        {
          item: item,
          quantity: newValue,
        }
      );
    },
    deleteItem(item) {
      this.isDrugsSummaryBusy = true;
      this.rugsSummaryBusyItemUuid = item.uuid;

      this.REQUEST_DELETE_IMPORTATION_CART_DRUG({
        current_item: item,
        drugsnapshot_uuid: item.uuid,
      }).then(
        () => {
          this.isDrugsSummaryBusy = false;
        },
        () => {
          this.isDrugsSummaryBusy = false;
        }
      );
    },
    onSaveForm(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.cleanFormFeedback();
      this.cleanFormState();
      var all_data_is_valid = this.$refs[
        "importmedicinesformfiles"
      ].validateAllUploaded();

      let promises = [];
      if (
        this.importation_cart.importation &&
        this.importation_cart.importation.uuid
      ) {
        promises.push(
          this.REQUEST_UPDATE_IMPORTATION_CART_IMPORTATION({
            importation_uuid: this.importation_cart.importation.uuid,
            data: this.form,
          }).then(undefined, err => {
            this.putFormFeedback(err.response);
            all_data_is_valid = false;
          })
        );
      } else {
        promises.push(
          this.REQUEST_CREATE_IMPORTATION_CART_IMPORTATION({
            data: this.form,
          }).then(undefined, err => {
            this.putFormFeedback(err.response);
            all_data_is_valid = false;
          })
        );
      }
      this.getImportationCartIsDirtyDrugs.forEach(drug => {
        if (drug.uuid) {
          promises.push(
            this.REQUEST_UPDATE_IMPORTATION_CART_DRUG({
              drugsnapshot_uuid: drug.uuid,
              // es importante que drug sea un item del store
              // de drugtransaction ya que usará la referencia
              // al objeto para actualizarlo
              current_item: drug,
              data: { quantity: drug.quantity },
            }).then(undefined, err => {
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("importmedicinesform.error.saving_drug_error"),
              });
              all_data_is_valid = false;
            })
          );
        } else {
          promises.push(
            this.REQUEST_CREATE_IMPORTATION_CART_DRUG({
              // es importante que drug sea un item del store
              // de drugtransaction ya que usará la referencia
              // al objeto para actualizarlo
              current_item: drug,
              data: drug,
            }).then(undefined, err => {
              this.$sentry({ capture: err });
              this.mnotify_error({
                text: this.$t("importmedicinesform.error.saving_drug_error"),
              });
              all_data_is_valid = false;
            })
          );
        }
      });

      if (
        !this.importation_cart_item_list_drugs ||
        this.importation_cart_item_list_drugs.length <= 0
      ) {
        all_data_is_valid = false;
        this.mnotify_error({
          text: this.$t("importmedicinesform.error.no_medicaments"),
        });
      }

      this.saving = true;
      Promise.all(promises).then(
        () => {
          if (all_data_is_valid) {
            this.REQUEST_UPDATE_IMPORTATION_CART({
              data: { object_status: 2 },
            }).then(
              () => {
                this.$router.push({ name: "importmedicinesdone" });
              },
              err => {
                this.mnotify_error({
                  text: this.$t("importmedicinesform.error.save_error"),
                });
                this.$sentry({ capture: err });
              }
            );
          } else {
            this.saving = false;
            this.mnotify_error({
              text: this.$t("importmedicinesform.error.review_form_and_files"),
            });
          }
        },
        err => {
          this.mnotify_error({
            text: this.$t("importmedicinesform.error.save_error"),
          });
          this.$sentry({ capture: err });
          this.saving = false;
        }
      );
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        importmedicinesform: {
          title: "Import of medicines to {country_name}",
          regulatory_org: "Regulatory organism",
          applicable_regulations: "Applicable regulations",
          kind_of_procedure: "Kind of procedure",
          regulatory_agency_cost: "Regulatory organism cost",
          required_time: "Required time",
          breadcrumb: "Import of medicines",
          documents_title: "Documents",
          drugs_title: "Drugs",
          add_drug_button: "Add",
          drug_selector_title: "Add new medicament",
          continue_button: "Continue",
          request_data_title: "Request data",
          firstname_label: "Complete name",
          firstname_placeholder: "",
          address_label: "Address",
          address_placeholder: "",
          postal_code_label: "Postal code",
          postal_code_placeholder: "",
          mobile_label: "Mobile",
          identification_number_label: "Identification number",
          identification_number_placeholder: "",
          town_label: "Town",
          town_placeholder: "",
          phone_label: "Phone",
          email_label: "email",
          email_placeholder: "",
          guide_subtitle: "Requirements guide and process to perform:",
          all_filled_info: "All documents must be duly filled out.",
          download_button: "Download",
          error: {
            saving_drug_error: "Cannot save drug",
            review_form_and_files: "Please, review form and files errors",
            save_error: "Error saving data, try again later.",
            no_medicaments: "Please, add at least one medicament.",
          },
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-light2 {
  background-color: #f9f9f9;
}
.flag-icon-background {
  background-position: initial !important;
}
.main-data-text {
  line-height: $line-height-base + 0.6;
}

.heading {
  font-size: $font-size-medium * 1.5;
}

.heading2 {
  color: $corp-color1;
  margin-bottom: 0.2rem;
}

.downloadbutton {
  background-color: #fff;
  color: #fe5e00;
  border: 2px solid #fe5e00;
  border-radius: 0.25rem !important;
}
</style>
